import useGlobalStore from 'hooks/useGlobalStore';

import type { OnboardingStepItem } from 'pages/OnboardingCurrentUserPage/hooks/useData/types';

import { COMPLETED, IN_PROGRESS, PENDING } from './constants';

const useOnboardingStepNavigation = () => {
    const { getValue, setValue } = useGlobalStore({
        namespace: 'onboardingData'
    });

    const currentOnboardingSteps = getValue('currentOnboardingSteps') as OnboardingStepItem[];
    const currentIndex = currentOnboardingSteps.findIndex(step => step.status === IN_PROGRESS);
    const currentStep = currentOnboardingSteps?.find(
        step => step.status === IN_PROGRESS
    ) as OnboardingStepItem;
    const stepNumber = (currentIndex + 1).toString();
    const canGoBack = currentIndex > 0;
    const canGoForward = currentStep.isValid === true;

    const buildStepsTo = (targetStepIndex: number): OnboardingStepItem[] => {
        const statusMap: Record<number, (s: OnboardingStepItem) => OnboardingStepItem> = {
            [currentIndex]: step => ({ ...step, status: step.isValid ? COMPLETED : PENDING }),
            [targetStepIndex]: step => ({ ...step, status: IN_PROGRESS })
        };

        return currentOnboardingSteps.map((step, index) =>
            statusMap[index] ? statusMap[index](step) : step
        );
    };

    const handleGoBack = () => {
        if (!canGoBack) {
            return false;
        }

        setValue({ currentOnboardingSteps: buildStepsTo(currentIndex - 1) });
    };

    const handleGoForward = () => {
        if (!canGoForward) {
            return;
        }

        setValue({ currentOnboardingSteps: buildStepsTo(currentIndex + 1) });
    };

    return {
        canGoBack,
        canGoForward,
        handleGoBack,
        handleGoForward,
        stepNumber
    };
};

export default useOnboardingStepNavigation;
